import { useCallback } from 'react';

import { useNavigate, useSearch } from '@tanstack/react-router';

import {
    type LeadDetailsModal,
    type LeadDetailsOverlaySearch,
    leadDetailsSearchSchema,
} from '~/features/leadDetails/schemas/leadDetailsSearch.schema';
import {
    clearLeadDetailsOverlaySearch,
    updateLeadDetailsOverlaySearch,
} from '~/features/leadDetails/utils/normalizeLeadDetailsSearch';

export type { LeadDetailsModal, LeadDetailsOverlaySearch };
export { clearLeadDetailsOverlaySearch as clearLeadDetailsModalSearch };

export function updateLeadDetailsModalSearch<Search extends LeadDetailsOverlaySearch>(
    search: Search,
    modal: LeadDetailsModal,
    open: boolean,
) {
    return updateLeadDetailsOverlaySearch(search, modal, open ? true : undefined);
}

export function useLeadDetailsModalNavigation() {
    const navigate = useNavigate();
    const search = leadDetailsSearchSchema.parse(useSearch({ strict: false }));

    const closeModal = useCallback(
        (modal: LeadDetailsModal) => {
            navigate({
                replace: true,
                search: (previous) => updateLeadDetailsModalSearch(previous, modal, false),
                to: '.',
            });
        },
        [navigate],
    );
    const openModal = useCallback(
        (modal: LeadDetailsModal) => {
            navigate({ search: (previous) => updateLeadDetailsModalSearch(previous, modal, true), to: '.' });
        },
        [navigate],
    );

    return {
        closeModal,
        isModalOpen: (modal: LeadDetailsModal) => Boolean(search[modal]),
        openModal,
    };
}
